import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';

// BrickmouldSize — shown when Brickmould is Loose or Installed
// Hides '1"' option when BrickmouldType = Standard
const ALL_OPTIONS = [
  { value: '1"',    label: '1"'    },
  { value: '1 5/8"', label: '1 5/8"' },
  { value: '2"',    label: '2"'    },
];

const BrickmouldSize = ({ value = { value: '', label: '' }, onChange, disabled = false, brickmouldType }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const skipValueSync = useRef(false);

  const options = brickmouldType?.value === 'Standard'
    ? ALL_OPTIONS.filter(o => o.value !== '1"')
    : ALL_OPTIONS;

  // Sync from parent
  useEffect(() => {
    if (skipValueSync.current) { skipValueSync.current = false; return; }
    setSelected(value?.value || '');
  }, [value?.value]);

  // Clear if current selection is no longer valid after type change
  useEffect(() => {
    if (selected && !options.find(o => o.value === selected)) {
      skipValueSync.current = true;
      setSelected('');
      onChange({ value: '', label: '' });
    }
  }, [brickmouldType?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = options.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdBrickmouldSize">Brickmould Size</label>
      <select id="SdBrickmouldSize" value={selected} onChange={handleChange} disabled={disabled}>
        {options.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BrickmouldSize;
